<template>
  <v-container fluid class="ncrm-data-protection">
    <NcrmHomePageHeader
      icon="mdi-shield-account-outline"
      :title="$t('ncrm.contacts.dataProtection.header')"
      :subtitle="$t(`${copyKey}.subtitle`)"
    />

    <v-tabs
      :model-value="state.section"
      color="primary"
      class="mt-4 mb-4"
      @update:model-value="navigate({ ...state, section: $event })"
    >
      <v-tab v-for="section in sections" :key="section" :value="section">
        {{ $t(`${copyKey}.sections.${section}`) }}
      </v-tab>
    </v-tabs>

    <NcrmPrivacyDashboard
      v-if="state.section === 'dashboard'"
      :view="subjectView"
      @update-view="replace({ ...state, view: $event })"
      @drill-down="navigate(drillDownState({ ...state, view: subjectView }, $event))"
      @open-failed-sync="navigate(failedSyncDrillDownState(state))"
    />
    <NcrmPrivacyRegistry
      v-else-if="state.section === 'registry'"
      :state="state"
      @update-state="replace"
    />
    <NcrmPrivacyPurposesSection v-else-if="state.section === 'purposes'" />
    <NcrmPrivacyNoticesSection v-else />
  </v-container>
</template>

<script>
import NcrmHomePageHeader from "@/components/ncrm/shared/NcrmHomePageHeader.vue";
import { hasPrivacyManagerRole } from "@/Utile/ncrmPrivacyAccess.mjs";
import NcrmPrivacyDashboard from "./NcrmPrivacyDashboard.vue";
import NcrmPrivacyNoticesSection from "./NcrmPrivacyNoticesSection.vue";
import NcrmPrivacyPurposesSection from "./NcrmPrivacyPurposesSection.vue";
import NcrmPrivacyRegistry from "./NcrmPrivacyRegistry.vue";
import {
  MANAGER_SECTIONS,
  SUBJECT_VIEWS,
  WORKSPACE_SECTIONS,
  buildWorkspaceQuery,
  drillDownState,
  failedSyncDrillDownState,
  parseWorkspaceQuery,
} from "./privacyWorkspaceContracts.mjs";

export default {
  name: "NcrmDataProtectionWorkspace",
  components: {
    NcrmHomePageHeader, NcrmPrivacyDashboard, NcrmPrivacyNoticesSection, NcrmPrivacyPurposesSection, NcrmPrivacyRegistry,
  },
  data: () => ({ canManage: false }),
  computed: {
    copyKey() { return "ncrm.contacts.dataProtection.workspace"; },
    sections() { return WORKSPACE_SECTIONS.filter((section) => this.canManage || !MANAGER_SECTIONS.includes(section)); },
    // O secțiune nepermisă rolului (link vechi, URL editat) cade pe dashboard.
    state() {
      const state = parseWorkspaceQuery(this.$route.query);
      return this.sections.includes(state.section) ? state : { ...state, section: "dashboard" };
    },
    // Dashboard-ul numără recorduri; o vedere de registru fără echivalent
    // (puncte de contact, evenimente) îl deschide pe Persoane.
    subjectView() { return SUBJECT_VIEWS.includes(this.state.view) ? this.state.view : "persons"; },
  },
  created() { this.canManage = hasPrivacyManagerRole(); },
  methods: {
    drillDownState,
    failedSyncDrillDownState,
    // Schimbarea secțiunii și drill-down-ul intră în istoric, ca Back să revină
    // la dashboard; filtrele și paginarea îl înlocuiesc, ca Back să nu parcurgă
    // fiecare literă tastată în căutare.
    navigate(next) { this.$router.push({ query: buildWorkspaceQuery(next) }); },
    replace(next) { this.$router.replace({ query: buildWorkspaceQuery(next) }); },
  },
};
</script>

<style scoped>
/* `main.css` centrează tot `#app`; un spațiu de lucru citește de la stânga. */
.ncrm-data-protection { text-align: left; }
</style>
